module.exports = __webpack_public_path__ + "media/images/top/top_user_img_02-b75ce1d98bfe2dc3841965d616585f16.png";